import React from 'react';

import IconCheckMark from '../icons/IconCheckMark';

import './index.css';

const CheckMark = (props) => {

  const onClick = (e) => {
    e.stopPropagation();
    if (props.row.confirmedTime) return;
    props.onClick(props.row);
  }

  return (
    <IconCheckMark onClick={onClick} className={props.row.confirmedTime ? '' : 'checkmark--checked'}/>
  );
}

export default CheckMark;